import { useEffect, useState } from "react";
import { isWebview } from "../utils";

/**
 * 현재는 어떤 웹뷰에 있든 true를 반환함
 * 추후에는 Disco app 내에서만 true가 반환될 수 있도록 수정되어야 함
 */
export const useInApp = (userAgent?: string) => {
  const [inApp, setInApp] = useState<boolean>(false);

  useEffect(() => {
    setInApp(isWebview(userAgent ?? window.navigator.userAgent));
  }, [userAgent]);

  return inApp;
}
